function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiusAllsidesblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14448"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5521",
    style: {
      fill: "#f3f3f3",
      stroke: "#ebebeb"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13604"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13600"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1938",
    transform: "translate(6 6)",
    style: {
      stroke: "#252529",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 1.5,
    style: {
      fill: "none"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiusAllsidesblack);
export default __webpack_public_path__ + "static/media/RadiusAllsidesblack.bf6943e8b3eec38c7fc9396300aaa2de.svg";
export { ForwardRef as ReactComponent };